import { fetchQuery, graphql } from "relay-runtime"
import {
  betterDocRecommendationsQuery as betterDocRecommendationsQueryDescriptor,
  Ch_betterDocRecommendationsInput,
} from "@/modules/patients/detail/better-doc/ch/services/__generated__/betterDocRecommendationsQuery.graphql"
import { RelayEnvironment } from "@/relay-environment"

export const betterDocRecommendationsQuery = graphql`
  query betterDocRecommendationsQuery($input: Ch_betterDocRecommendationsInput!, $language: String!) {
    ch_betterDocRecommendations(input: $input) {
      status
      careProviders {
        __typename
        id
        businessName
        firstName
        lastName
        title
        groupName(language: $language)
        careProviderGroup {
          groupType
        }
        careProviderSpecialtyTranslations(language: $language) {
          name
        }
        city
        postalCode
        streetAddress
        country {
          countryName(language: $language)
        }
        relationType
        relationBusinessName
        relationFirstName
        relationLastName
        relationTitle
      }
    }
  }
`
export const fetchBetterDocRecommendations = async (input: Ch_betterDocRecommendationsInput, language: string) => {
  const response = await fetchQuery<betterDocRecommendationsQueryDescriptor>(
    RelayEnvironment,
    betterDocRecommendationsQuery,
    {
      input,
      language,
    },
  ).toPromise()
  return response?.ch_betterDocRecommendations
}
